document.addEventListener("DOMContentLoaded", function ()
{
    const carousel = document.querySelector(".bp-carousel");
    const btnPrev = document.querySelector(".bp-prev");
    const btnNext = document.querySelector(".bp-next");

    if(!carousel || !btnPrev || !btnNext) return;

    function smoothScrollTo(target)
    {
        const start = carousel.scrollLeft;
        const distance = target - start;
        const duration = 350;
        const startTime = performance.now();

        function animation(currentTime)
        {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const ease = 0.5 - Math.cos(progress * Math.PI) / 2; // easing suave

            carousel.scrollLeft = start + distance * ease;

            if(progress < 1) {
                requestAnimationFrame(animation);
            }
        }

        requestAnimationFrame(animation);
    }

    btnNext.addEventListener("click", function ()
    {
        const maxScroll = carousel.scrollWidth - carousel.clientWidth;

        if(carousel.scrollLeft >= maxScroll - 5) {
            // volta para o início suave
            smoothScrollTo(0);
        } else {
            smoothScrollTo(carousel.scrollLeft + 250);
        }
    });

    btnPrev.addEventListener("click", function ()
    {
        if (carousel.scrollLeft <= 5) {
            // volta para o final suave
            const maxScroll = carousel.scrollWidth - carousel.clientWidth;
            smoothScrollTo(maxScroll);
        } else {
            smoothScrollTo(carousel.scrollLeft - 250);
        }
    });
});
